export class Util {
  /** APIエンドポイント文字列の生成 */
  endPointCreator(
    requestBasePath: string,
    ...paths: (string | number)[]
  ): string {
    return `${requestBasePath}/${paths.join('/')}`;
  }
}
